"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { Component, Mixins } from "vue-property-decorator";
import { AccountSessionMixins } from "@/service/account-session";
import API from "@ym-framework/api-utils";
import { APIDataSource } from "@/components/grid/data-source";
import UiGrid, { GridController } from "@/components/grid/UiGrid.vue";
import DateFormat from "@/framework/timeformatter";
import { Debounce } from "vue-debounce-decorator";
let FlowManager = class extends Mixins(AccountSessionMixins) {
  constructor() {
    super(...arguments);
    this.gridController = new GridController(
      new APIDataSource("api://base.auth.pro/v1/traffics-history")
    );
    this.flowDetail = "0GB";
    this.searchData = {
      ip: "",
      vdName: "",
      createdTime: [
        new Date(
          new Date(new Date().toLocaleDateString()).getTime() - 3600 * 1e3 * 24 * 7
        ),
        new Date(
          new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1e3 - 1
        )
      ]
    };
    this.pickerOptions = {
      shortcuts: [
        {
          text: this.$t("loginlogs.today"),
          onClick(picker) {
            const end = new Date(
              new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1e3 - 1
            );
            const start = new Date(
              new Date(new Date().toLocaleDateString()).getTime()
            );
            start.setTime(new Date(start.toLocaleDateString()).getTime());
            picker.$emit("pick", [start, end]);
          }
        },
        {
          text: this.$t("loginlogs.lastday"),
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(
              new Date(start.toLocaleDateString()).getTime() - 3600 * 1e3 * 24
            );
            start.setHours(0, 0, 0, 0);
            end.setTime(new Date(end.toLocaleDateString()).getTime());
            picker.$emit("pick", [start, end]);
          }
        },
        {
          text: this.$t("loginlogs.thisweek"),
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(
              start.getTime() - (start.getDay() - 1) * 3600 * 1e3 * 24
            );
            start.setHours(0, 0, 0, 0);
            picker.$emit("pick", [start, end]);
          }
        },
        {
          text: this.$t("loginlogs.lastsevenday"),
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1e3 * 24 * 7);
            start.setHours(0, 0, 0, 0);
            picker.$emit("pick", [start, end]);
          }
        },
        {
          text: this.$t("loginlogs.lastweek"),
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(
              start.getTime() - (start.getDay() + 6) * 3600 * 1e3 * 24
            );
            start.setHours(0, 0, 0, 0);
            end.setTime(end.getTime() + (0 - end.getDay()) * 3600 * 1e3 * 24);
            picker.$emit("pick", [start, end]);
          }
        },
        {
          text: this.$t("loginlogs.thismonth"),
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.setDate(1));
            start.setHours(0, 0, 0, 0);
            picker.$emit("pick", [start, end]);
          }
        },
        {
          text: this.$t("loginlogs.lastthirtydays"),
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1e3 * 24 * 30);
            start.setHours(0, 0, 0, 0);
            picker.$emit("pick", [start, end]);
          }
        },
        {
          text: this.$t("loginlogs.lastmonth"),
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(
              new Date(start.setMonth(start.getMonth() - 1)).setDate(1)
            );
            start.setHours(0, 0, 0, 0);
            end.setTime(end.setDate(1));
            picker.$emit("pick", [start, end]);
          }
        }
      ],
      disabledDate(time) {
        return time.getTime() > new Date(
          new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1e3 - 1
        ) || time.getTime() < new Date(new Date().setMonth(new Date().getMonth() - 6));
      }
    };
  }
  mounted() {
    return __async(this, null, function* () {
      this.gridController.query.sort = "createdTime,desc";
      this.gridController.query.filter = "createdTime=sort=desc;";
      yield this.Search();
      yield this.buyFlowPackage();
    });
  }
  buyFlowPackage() {
    return __async(this, null, function* () {
      try {
        let response = yield API.get(`api://base.auth.pro/v1/accounts/dashboard`);
        this.flowDetail = response.data.trafficBalance.toString() + "GB";
      } catch (error) {
      }
    });
  }
  refresh() {
    return __async(this, null, function* () {
      yield this.gridController.search();
    });
  }
  // 流量充值
  chargeTraffic() {
    return __async(this, null, function* () {
      try {
        this.$router.push({ path: "/traffic" });
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  Search() {
    return __async(this, null, function* () {
      this.gridController.query.filter = "createdTime=sort=desc;";
      if (this.searchData.ip && this.searchData.ip !== "") {
        this.gridController.query.filter += `ip==${this.searchData.ip};`;
      }
      if (this.searchData.vdName && this.searchData.vdName !== "") {
        this.gridController.query.filter += `vdName=like="${this.searchData.vdName}";`;
      }
      if (this.searchData.createdTime && this.searchData.createdTime.length > 0) {
        let mintime = Date.parse(this.searchData.createdTime[0]) / 1e3;
        let maxtime = Date.parse(this.searchData.createdTime[1]) / 1e3;
        this.gridController.query.filter += `createdTime=between=(${mintime},${maxtime});`;
      }
      yield this.gridController.search();
    });
  }
  format_login_time(time) {
    if (time === 0 || time === null) {
      return "--";
    } else {
      return DateFormat.dateformat(DateFormat.check(time));
    }
  }
};
__decorateClass([
  Debounce(500)
], FlowManager.prototype, "Search", 1);
FlowManager = __decorateClass([
  Component({
    components: { UiGrid }
  })
], FlowManager);
export {
  FlowManager as default
};
